<template>
    <div id="datatable-entity_backoffice">
        <v-data-table
            :headers="headersMaster"
            :items="logsList"
            show-expand
            :single-expand="singleExpand"
            :page="page"
            :pageCount="numberOfPages"
            :expanded.sync="expanded"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 20, 50],
            }"
            item-key="uniqueGuid"
        >
            <template v-slot:[`item.createdOn`]="{ item }">
                {{ item.createdOn | formatOnlyDate }}
            </template>
            <template v-slot:[`expanded-item`]="{ headers, item }">
                <td :colspan="headers.length">
                    <div class="mt-3 mb-3">
                        <v-data-table
                            class="elevation-5"
                            hide-default-footer
                            :headers="headersDetails"
                            :items="item.logs"
                            item-key="uniqueGuid"
                        >
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            class="mr-2 p-0 circle"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="showDiff(item)"
                                        >
                                            <img
                                                src="/images/_SVGs/bo/eye.svg"
                                                class="circle"
                                                onload="SVGInject(this)"
                                                width="12"
                                                height="12"
                                            />
                                        </span>
                                    </template>
                                    <span>{{
                                        $t("backoffice.logs.see-changes")
                                    }}</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </div>
                </td>
            </template>
        </v-data-table>

        <base-modal
            v-model="modalDiff.show"
            :title="$t('backoffice.logs.changes')"
            modal-width="1500px"
            @watch-show-value="clickOutsideModalDiff"
        >
            <template v-slot:modal-body>
                <code-diff
                    :old-string="modalDiff.oldStr"
                    :new-string="modalDiff.newStr"
                    :outputFormat="modalDiff.outputFormat"
                    file-name="test.txt"
                    :diff-style="modalDiff.diffStyle"
                    :trim="modalDiff.trim"
                    :is-show-no-change="modalDiff.isshowNoChange"
                />
            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn
                        @click="modalDiff.show = false"
                        class="primary-button"
                        text
                    >
                        {{ $t("close") }}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import { CodeDiff } from "v-code-diff";
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {BaseModal, CodeDiff },
    props: {
        logsList: Array | Object,
        searchCount: Number,
        totalItems: Number | String,
    },
    data() {
        return {
            headersMaster: [
                {
                    text: this.$t('backoffice.logs.table.unique-guid'),
                    align: "start",
                    value: "uniqueGuid",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.logs.table.module-name'),
                    align: "start",
                    value: "moduleName",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.logs.table.created-by-name'),
                    value: "createdByName",
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.logs.table.created-on'),
                    value: "createdOn",
                    class: "header-table-color",
                },
                {
                    text: "",
                    value: "data-table-expand",
                    class: "header-table-color",
                },
            ],
            headersDetails: [
                {
                    text: this.$t('backoffice.logs.table.platform-id'),
                    value: "plataformLogID",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.logs.table.table-name'),
                    value: "tableName",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.logs.table.method-name'),
                    value: "methodName",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.logs.table.action-name'),
                    value: "actionName",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.logs.table.created-time'),
                    value: "createTime",
                    sortable: false,
                    class: "header-table-color",
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "right",
                    class: "header-table-color",
                },
            ],
            singleExpand: true,
            expanded: [],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            modalDiff: {
                show: false,
                outputFormat: "side-by-side",
                newStr: "",
                oldStr: "",
                diffStyle: "word",
                trim: true,
                isshowNoChange: true
            },
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.sortBy": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        searchCount: {
            handler() {
                this.options.page = 1;
            },
        },
    },
    methods: {
        clickOutsideModalDiff(value) {
            this.modalDiff.show = value;
        },
        showDiff(item) {
            this.modalDiff.oldStr = item.activityJsonOldLog
                ? JSON.stringify(JSON.parse(item.activityJsonOldLog), null, 2)
                : "";
            this.modalDiff.newStr = item.activityJsonLog
                ? JSON.stringify(JSON.parse(item.activityJsonLog), null, 2)
                : "";
            this.modalDiff.show = true;
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-entity_backoffice {
    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }
    .star {
        color: #ffc117 !important;
    }

    .bold-style {
        font-weight: bold;
    }

    .v-data-footer {
        margin-right: 40px !important;
    }
}
</style>
